module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', [_c('code', [_vm._t("default", [_vm._v("なんもないよ！")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b2a5d60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/HighLight.vue
// module id = 1339
// module chunks = 0